import AjaxInvitationService from './ajax-invitation-service'

class BuildingConsentService extends AjaxInvitationService {
  
  getConsent(building_id, code) {
    const data = { building_id:building_id, appointment:1, active:1 }
    const headers = this.getInvitationHeader(code)
    return this.makeGetRequest('/by-invitation/building-consents', data, headers)
  }

  agree(data) {
    const headers = this.getInvitationHeader(data.code)
    return this.makePostRequest('/by-invitation/building-consents/agree', data, headers)
  }

}

const _instance = new BuildingConsentService()
export default _instance